var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZimbabwe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_17633)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_17633",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_17633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3H43V23H3V3Z",
    fill: "#319208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5.85715H43V20.1429H3V5.85715Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 8.71428H43V17.2857H3V8.71428Z",
    fill: "#DE2010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11.5714H43V14.4286H3V11.5714Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72746 3L17.0608 13L3.72746 23H3V3H3.72746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3L16.3333 13L3 23",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3272 13.4833L13.2276 11.4303L9.88969 10.9454L8.39683 7.92064L6.90398 10.9454L3.56604 11.4303L6.46652 13.4833L5.83112 16.5314L8.39683 15.0635L10.9625 16.5314L10.3272 13.4833Z",
    fill: "#DE2010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.54524 11.7475C7.85889 12.4308 7.9373 12.4757 8.72158 12.7446C9.50571 13.0135 11.7213 13.2684 11.9397 13.2935C11.7968 13.1506 9.30143 11.3022 8.78889 10.9324C8.27635 10.5627 8.13349 10.3946 8.13349 10.3946C8.13349 10.3946 7.67143 9.56286 7.51174 9.31905C7.35206 9.0754 7.05809 8.73096 6.67158 8.73096C6.28508 8.73096 6.04984 8.95778 5.93778 9.36112C5.87619 9.37794 5.54571 9.57953 5.55682 9.78683C5.65206 9.77556 6.25143 9.60762 6.45873 10.2854C6.66603 10.9632 6.67714 12.0722 6.46428 12.6213C6.25143 13.1703 5.92095 13.5848 5.92095 14.0665C5.92095 14.1337 5.96571 14.2681 6.07778 14.2681C6.11698 14.481 6.43063 15.9989 6.43063 15.9989H10.9006L11.6106 13.2541",
    fill: "#FFC618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.54524 11.7475C7.85889 12.4308 7.9373 12.4757 8.72158 12.7446C9.50571 13.0135 11.7213 13.2684 11.9397 13.2935C11.7968 13.1506 9.30143 11.3022 8.78889 10.9324C8.27635 10.5627 8.13349 10.3946 8.13349 10.3946C8.13349 10.3946 7.67143 9.56286 7.51174 9.31905C7.35206 9.0754 7.05809 8.73096 6.67158 8.73096C6.28508 8.73096 6.04984 8.95778 5.93778 9.36112C5.87619 9.37794 5.54571 9.57953 5.55682 9.78683C5.65206 9.77556 6.25143 9.60762 6.45873 10.2854C6.66603 10.9632 6.67714 12.0722 6.46428 12.6213C6.25143 13.1703 5.92095 13.5848 5.92095 14.0665C5.92095 14.1337 5.96571 14.2681 6.07778 14.2681C6.11698 14.481 6.43063 15.9989 6.43063 15.9989H10.9006L11.6106 13.2541",
    stroke: "black",
    strokeWidth: 0.212
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07776 14.2683C6.07776 14.2683 7.02998 14.2122 7.28776 14.2122C7.54538 14.2122 9.94395 14.2153 11.2822 14.5246",
    stroke: "black",
    strokeWidth: 0.212
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41392 14.2494C6.41392 14.2494 6.31853 14.1338 6.38012 13.9041C6.4417 13.6744 7.11392 13.0806 7.11392 12.2405M6.99075 14.2122C6.99075 14.2122 6.91234 13.837 7.76932 13.5176C8.01027 13.4448 8.69916 13.0583 8.72154 12.7446M7.67821 13.5532C7.67821 13.5532 9.78027 13.5624 11.4439 13.8984",
    stroke: "black",
    strokeWidth: 0.212
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20519 13.3024C8.20519 13.3024 8.92757 13.3272 9.04519 13.2935C9.16281 13.2599 9.37106 13.1726 9.45392 12.9264M8.63328 13.311C8.63328 13.311 9.01963 13.1102 9.09535 12.8489M7.46678 15.9991C7.46678 15.9991 7.30154 14.8537 7.26789 14.2122L7.69916 14.624L8.15551 14.2249L8.54789 14.6437L9.00154 14.2587L9.39376 14.6997L9.84297 14.3176L10.2004 14.7332L10.6484 14.4092L11.1809 14.9154M11.0874 15.277C9.48725 15.0478 7.34614 15.0627 7.34614 15.0627M6.60217 11.1035C6.60217 11.1035 7.90376 10.4816 8.13344 10.3948",
    stroke: "black",
    strokeWidth: 0.212
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30374 14.6661L7.74127 15.0644L8.13659 14.6691L8.5364 15.0813L8.96815 14.6996L9.36565 15.1174L9.81397 14.7472L10.1802 15.175L10.6262 14.834L11.095 15.2481",
    stroke: "black",
    strokeWidth: 0.21174
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54521 14.0834C8.64112 14.0834 8.71887 14.0057 8.71887 13.9098C8.71887 13.8139 8.64112 13.7361 8.54521 13.7361C8.4493 13.7361 8.37155 13.8139 8.37155 13.9098C8.37155 14.0057 8.4493 14.0834 8.54521 14.0834Z",
    stroke: "black",
    strokeWidth: 0.21174
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.27831 14.1326C9.37422 14.1326 9.45197 14.0548 9.45197 13.9589C9.45197 13.863 9.37422 13.7853 9.27831 13.7853C9.1824 13.7853 9.10464 13.863 9.10464 13.9589C9.10464 14.0548 9.1824 14.1326 9.27831 14.1326Z",
    stroke: "black",
    strokeWidth: 0.21174
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54966 9.40328C6.62391 9.40328 6.6841 9.34309 6.6841 9.26884C6.6841 9.19459 6.62391 9.1344 6.54966 9.1344C6.47541 9.1344 6.41522 9.19459 6.41522 9.26884C6.41522 9.34309 6.47541 9.40328 6.54966 9.40328Z",
    stroke: "black",
    strokeWidth: 0.21174
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_17633",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_17633"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_17633",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZimbabwe);
export default __webpack_public_path__ + "static/media/Zimbabwe.c82515a038a9d4a08da3e51f2283f1fd.svg";
export { ForwardRef as ReactComponent };